import React from "react";
import useMultiTabForm from "./useMultiTabForm";
// import Style from '../customers.module.scss';
import { FormTabs } from "../../../Global/FormTabs";
import Style  from "../orders.module.scss";

function MultiTabForm({ setShowform, refetch }) {
  const { tabs, activeTab, handleTabClick, formik, renderTabContent } =
    useMultiTabForm(setShowform, refetch);

  return (
    <div>
      <FormTabs
      isScroll={true}
      tabs={tabs} active={activeTab} handleClick={handleTabClick} />
      <div>{renderTabContent()}</div>
    </div>
  );
}

export default MultiTabForm;
